import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from '../ButtonLink';
import LazyImg from '../LazyImg';
import css from './ShopPoster.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ShopPoster = function ShopPoster(_ref) {
  var cta = _ref.cta,
      image = _ref.image,
      imageMobile = _ref.imageMobile,
      message = _ref.message,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(LazyImg, {
      alt: "Shop Poster",
      className: cc([css.img, _defineProperty({}, css.desktop, imageMobile)]),
      src: image
    }), imageMobile && /*#__PURE__*/_jsx(LazyImg, {
      alt: "Shop Poster",
      className: cc([css.img, css.mobile]),
      src: imageMobile
    }), /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.spacer
      }), /*#__PURE__*/_jsx("h2", {
        className: css.message,
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), /*#__PURE__*/_jsx("div", {
        className: css.button,
        children: /*#__PURE__*/_jsx(ButtonLink, {
          borderedHover: true,
          big: true,
          href: url,
          children: cta
        })
      })]
    })]
  });
};

ShopPoster.defaultProps = {
  imageMobile: false
};
ShopPoster.propTypes = {
  cta: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  message: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
export default ShopPoster;